export default (
  itemsCount = 0,
  maxCount = 10,
  rowHeight = 42,
  initialHeight = 80
) => {
  const count = itemsCount >= maxCount ? maxCount : itemsCount;
  return initialHeight + count * rowHeight;
};
